import {
  baseApiUrl,
  apiUrl,
  pnUrl,
  ffUrl,
  errorUrl,
  partsTableUrl,
  newHeader,
  currentImgs,
  assetURL,
} from "./World/config.js";

import EventHub from "./Utils/EventManagement/EventHub.js";
import { DataProvider } from "./Utils/DataVault/DataProvider.js";
import ImageVault from "./Utils/ImageVault/ImageVault.js";
import DataVault from "./Utils/DataVault/DataVault.js";
import * as THREE from "three";
import Debug from "./Utils/Debug.js";
import Sizes from "./Utils/Sizes.js";
import Time from "./Utils/Time.js";
import Camera from "./Camera.js";
import Renderer from "./Renderer.js";
import World from "./World/World.js";
import Resources from "./Utils/Resources.js";
import sources from "./sources.js";
import Raycaster from "./Utils/Raycaster.js";
import Environment from "./World/Environment/Environment.js";
import myObject from "./Utils/object.js";
import GlobalEventTracker from "./Utils/EventManagement/GlobalEventTracker.js";
import UIEventTracker from "./Utils/EventManagement/UIEventTracker.js";
import CameraSwap from "./World/CameraSwap.ts";
import AlignCamera from "./World/alignCamera.ts";
// import GizmoManager from "./Manipulation/GizmoManager";
// import ManipulationManager from "./Manipulation/ManipulationManager";
// import SnappingManager from "./Manipulation/SnappingManager";
// import TransformControls from "./Manipulation/TransformControls";
import UndoRedoManager from "../Components/UndoRedoManager/UndoRedoManager.js";
import MarqueeSelection from "./ObjectManagement/MarqueeSelection";
import ObjectSelector from "./ObjectManagement/ObjectSelector";
import SelectionManager from "./ObjectManagement/SelectionManager";
import VisualFeedbackManager from "./ObjectManagement/VisualFeedbackManager";
import XmdTracker from "../Components/XmdManager/XmdTracker.js";
import { DesignManager } from "../Components/DesignManager/DesignManager.js";
import ZoomAll from "./World/ZoomAll.js";

import DetectCollision from "./ObjectManagement/DetectCollision.js";
import MoveObject from "./Manipulation/MoveObject.js";
import ShapeManager from "../Components/ShapeManager/ShapeManager.js";
import MakeParts from "./World/MakeParts.js";

import ConnectionManager from "./ObjectManagement/ConnectionManager.js";
import RotateManager from "./Manipulation/RotateManager.js";
import Transparency from "./Manipulation/Transparency.js";
import DeleteScene from "./ObjectManagement/DeleteScene.js";
import PartChooser from "./ObjectManagement/ChooseDiffPart/PartChooser.js";
import debug from "debug";
import XmdLoader from "../Components/XmdManager/XmdLoader.js";
import TextureVault from "./Utils/TextureVault/TextureVault.js";
import { BomData } from "../Components/BOM/BomData.js"; // Import BomData
import { PowerTableData } from "../Components/PowerTable/PowerTableData.js";
import Tooltip from "./Manipulation/Tooltip.js";
import TextureSwitcher from "./World/TextureSwitcher.js";
import PortVault from "./Utils/AssetVault/PortVault.js";
import MouseTracker from "./World/MouseTracker.js";
import GeometrySwitcher from "./World/GeometrySwitcher.js";
import Loader from "./World/Loader.js";
import AssetVault from "./Utils/AssetVault/AssetVault.js";
import CleanupInspector from "./Utils/CleanupInspector.js";
import LoadingOverlay from "./Utils/Overlay/LoadingOverlay.js";
import EdgeManager from "./World/EdgeManager.ts";
import PostProcessingManager from "./PostProcessing/PostProcessingManager.js";
import globalTablePartPlacement from "../Components/Tables/GlobalTable/globalTablePartPlacement.ts";
import Loading3D from "./Utils/Overlay/Loading3D.ts";
import ExplodedView from "./Utils/ExplodedView.ts";
import LoginManager from "../Components/Keycloak/LogInManager.ts";
import XmdCacheManager from "../Components/XmdManager/XmdCacheManager.ts";
import SelectionHighlightManager from "./ObjectManagement/SelectionHighlightManager.ts";
import { SvelteUIController } from "../Components/SvelteUI/SvelteUIController.ts";
import ActivityTracker from "./Utils/Activity/ActivityTracker.ts";
import InactivityLogoutManager from "./Utils/Activity/InactivityLogoutManager.ts";
import {
  getViewDesignIdFromPath,
  getViewDesignSourceFromPath,
} from "../lib/utils/viewDesignRoute.js";
const log = debug("app:experience");

let instance = null;

/**
 * The `Experience` class is a singleton that initializes and manages the 3D scene,
 * rendering, event handling, and various components related to the application.
 * @category Experience
 */
export default class Experience {
  /**
   * Creates an instance of `Experience`.
   * Ensures that only one instance exists (Singleton pattern).
   */
  constructor() {
    // Singleton
    if (instance) {
      return instance;
    }
    instance = this;

    // Add config properties to the experience instance
    this.config = {
      baseApiUrl,
      apiUrl,
      pnUrl,
      ffUrl,
      errorUrl,
      partsTableUrl,
      newHeader,
      currentImgs,
      assetURL,
    };

    /**
     * Centralized user authentication state for the entire app.
     * Possible values:
     * - "guest"        : not authenticated
     * - "authenticated": has a valid session/token
     * - "expired"      : session expired due to inactivity (transient, usually flows back to "guest")
     */
    this.userState = "guest";

    /** True when viewing a locked design from RFQ "View Design" link — read-only, save disabled */
    this.isLockedDesignView = false;

    // Initialize eventHub and dataProvider before passing them
    this.eventHub = EventHub.getInstance();
  }
  async init() {
    this.LoginManager = LoginManager.getInstance();
    await this.LoginManager.init(this.eventHub);

    // Keep userState in sync with authentication events
    this.userState = this.LoginManager.isAuthenticated()
      ? "authenticated"
      : "guest";
    this.eventHub.on("auth:login", () => {
      this.userState = "authenticated";
    });
    this.eventHub.on("auth:guest", () => {
      this.userState = "guest";
    });
    this.eventHub.on("sign_out", () => {
      // After an explicit sign out we treat the user as guest
      this.userState = "guest";
    });
    this.eventHub.on("sessionExpired", () => {
      // Mark as expired immediately; LoginManager will emit auth:guest/sign_out when logout completes
      this.userState = "expired";
    });
    this.dataProvider = new DataProvider(this); // Pass the experience instance to DataProvider
    this.dataVault = DataVault.getInstance(this);
    this.undoRedoManager = UndoRedoManager.getInstance(this);
    this.imageVault = ImageVault.getInstance(this);

    this.globalEventTracker = new GlobalEventTracker(this);
    this.uiEventTracker = new UIEventTracker(this);
    this.activityTracker = new ActivityTracker(this);
    // Production timeouts: 15 minutes idle, 15 minutes warning before auto-logout
    this.inactivityLogoutManager = new InactivityLogoutManager(this, 900, 900);

    var pathFile = myObject.viewer.model.path;

    // Global access
    window.experience = this;
    //(myObject.viewer)
    // Options
    const canvasDomElement = myObject.viewer.canvas.canvasDomElement;
    this.canvas = canvasDomElement;

    // Setup
    this.debug = new Debug();
    this.sizes = new Sizes();

    this.time = new Time();

    this.scene = new THREE.Scene();

    this.cssScene = new THREE.Scene();

    this.resources = new Resources(sources);
    this.camera = new Camera(myObject);
    this.renderer = new Renderer(myObject);
    this.world = new World(this);
    this.raycaster = new Raycaster(this);
    this.marqueeSelection = new MarqueeSelection(this);
    this.objectSelector = new ObjectSelector(this);
    this.selectionManager = new SelectionManager(this);
    this.visualFeedbackManager = new VisualFeedbackManager(this);
    this.selectionHighlightManager = new SelectionHighlightManager(this);
    this.detectCollision = new DetectCollision(this);
    this.moveObject = new MoveObject(this);
    this.environment = new Environment(myObject);
    this.makeParts = new MakeParts();
    this.XmdTracker = new XmdTracker(this);
    this.bomData = new BomData(this);
    this.powerTableData = new PowerTableData(this);
    this.designManager = new DesignManager(this);
    this.cameraSwap = new CameraSwap(this);
    this.alignCamera = new AlignCamera(this);
    this.zoomAll = new ZoomAll(this);
    this.Tooltip = new Tooltip(this);

    //const connectionManager = new ConnectionManager(this);
    const transparency = new Transparency(this);
    const rotateManager = new RotateManager(this);
    this.deleteScene = new DeleteScene(this);
    this.partChooser = new PartChooser(this);
    this.xmdLoader = new XmdLoader(this);
    this.textureVault = TextureVault.getInstance(this);
    this.portVault = PortVault.getInstance(this);
    this.assetVault = AssetVault.getInstance(this);
    this.textureSwitcher = new TextureSwitcher(this);
    this.mouseTracker = new MouseTracker(this);
    this.geometrySwitcher = new GeometrySwitcher(this);
    this.cleanupInspector = new CleanupInspector(this);
    this.LoadingOverlay = new LoadingOverlay(this);
    this.EdgeManager = new EdgeManager(this);
    this.postProcessing = new PostProcessingManager(this);
    this.globalTablePartPlacement = new globalTablePartPlacement(this);
    this.Loading3D = new Loading3D(this);
    this.ExplodedView = new ExplodedView(this);
    this.XmdCacheManager = new XmdCacheManager(this);
    this.svelteUIController = new SvelteUIController(this);
    this.renderer.update();
    // this.renderer.resize()
    THREE.Cache.enabled = true;
    this.loader = new Loader(this);
    this.mouse = new THREE.Vector2();
    // Resize event
    /*     this.eventHub.on("resize", () => {
      this.resize();
    }); */

    // Time tick event
    this.time.on("tick", () => {
      this.update();
    });

    this.addWindowListeners();

    // View Design link: ?view-design?<id> or /view-design/:id (legacy path) — load design via same API as "Open saved design"
    this.tryViewDesignFromUrl();
  }

  /**
   * If the URL has ?view-design?<designId> (or legacy path), defer the load until
   * login status is verified so we only request the design once we know the user has access.
   * Then load via the same API and flow as "Open saved design" (GET /api/v1/design/:id).
   * No JWT after auth → redirect to Keycloak with return URL; after login the page reloads and we load.
   *
   * When the URL also contains &source=admin, unauthenticated users see an "Admin Access Required"
   * popup with a Log In button instead of being silently redirected to Keycloak.
   */
  async tryViewDesignFromUrl() {
    const designId = getViewDesignIdFromPath();
    if (!designId) return;

    log("View Design URL detected, designId:", designId);

    const source = getViewDesignSourceFromPath();
    const isAdminSource = source === "admin";

    const XMD_CACHE_KEY = "xmdVaultCache";

    const doLoad = async () => {
      const token = await this.LoginManager.getToken();
      if (!token) {
        log("View Design: no JWT, redirecting to login with return URL");
        this.LoginManager.login({ redirectUri: window.location.href });
        return;
      }
      try {
        // Clear scene and session cache so only the URL design is loaded (no cached design).
        this.eventHub.emit("deleteScene");
        sessionStorage.removeItem(XMD_CACHE_KEY);

        await this.waitForDataVaultReady();
        await this.designManager.loadDesignFromApi(designId);
        log("View Design: design loaded into configurator");
        // Clean up URL params now that the design is loaded — keeps the address bar tidy
        // and prevents the load from re-triggering on a manual refresh.
        history.replaceState({}, "", window.location.pathname);
      } catch (error) {
        log("View Design: failed to fetch or load design", error);
      }
    };

    await this.LoginManager.ready;

    const token = await this.LoginManager.getToken();
    if (token) {
      // User is authenticated — load the design (backend enforces admin access if needed).
      await doLoad();
      return;
    }

    // User is not authenticated.
    if (isAdminSource) {
      // Show a friendly popup instead of an immediate Keycloak redirect.
      // The popup's Log In button triggers signInClick → LoginManager.login().
      // After Keycloak login the page reloads and the design is loaded on next visit.
      log(
        "View Design: source=admin, user is guest — showing admin login popup",
      );
      this.eventHub.emit("showAdminLoginModal");
      return;
    }

    // Default guest behavior: wait for auth events then act.
    this.eventHub.once("auth:login", doLoad);
    this.eventHub.once("auth:guest", () => {
      log("View Design: user is guest, redirecting to login with return URL");
      this.LoginManager.login({ redirectUri: window.location.href });
    });
  }

  /**
   * Waits for DataVault to finish loading (parts, form factors, etc.) so that
   * design load can resolve part numbers. Resolves after "loading-finished" or
   * after a timeout so we don't block forever.
   */
  waitForDataVaultReady() {
    return new Promise((resolve) => {
      const timeoutMs = 15000;
      const timeoutId = setTimeout(() => {
        this.eventHub.off("loading-finished", onReady);
        log("View Design: DataVault wait timed out, proceeding anyway");
        resolve();
      }, timeoutMs);
      const onReady = () => {
        clearTimeout(timeoutId);
        resolve();
      };
      this.eventHub.once("loading-finished", onReady);
    });
  }

  /*   resize() {
    this.camera.resize();
  } */

  /**
   * Updates the experience by updating the camera, world, and renderer.
   * This method is called on each animation frame.
   * Renderer (including post-processing) only runs when needsRender is true,
   * stopping after ~3s of no camera manipulation or other render-triggering events.
   */
  update() {
    this.camera.update();
    this.world.update();
    if (this.renderer.needsRender) {
      this.renderer.update();
    }
  }

  /**
   * Destroys the experience instance, cleaning up event listeners,
   * disposing of Three.js objects, and releasing memory.
   */

  addWindowListeners() {
    window.addEventListener("unload", () => {
      this.cleanup();
      const logs = JSON.parse(localStorage.getItem("cleanupLogs")) || [];
      logs.push(`Cleanup started at ${new Date().toISOString()}`);
      localStorage.setItem("cleanupLogs", JSON.stringify(logs));
    });

    window.addEventListener("load", () => {
      this.killCleanupWorker();
      this.initializeCleanupWorker();
    });
  }

  cleanup() {
    console.log("Main: Starting cleanup...");

    const cleanupTasks = [
      "eventHub",
      "dataProvider",
      "dataVault",
      "undoRedoManager",
      "imageVault",
      "globalEventTracker",
      "uiEventTracker",
      "activityTracker",
      "inactivityLogoutManager",
      "debug",
      "sizes",
      "time",
      "scene",
      "cssScene",
      "resources",
      "camera",
      "renderer",
      "world",
      "raycaster",
      "marqueeSelection",
      "objectSelector",
      "selectionManager",
      "visualFeedbackManager",
      "selectionHighlightManager",
      "detectCollision",
      "moveObject",
      "environment",
      "makeParts",
      "XmdTracker",
      "bomData",
      "powerTableData",
      "designManager",
      "cameraSwap",
      "zoomAll",
      "Tooltip",
      "deleteScene",
      "partChooser",
      "xmdLoader",
      "textureVault",
      "portVault",
      "assetVault",
      "textureSwitcher",
      "mouseTracker",
      "geometrySwitcher",
      "cleanupInspector",
      "LoadingOverlay",
    ];

    cleanupTasks.forEach((task) => {
      if (this[task] && typeof this[task].cleanup === "function") {
        console.log(`Main: Cleaning up ${task}`);
        this[task].cleanup();
        this[task] = null; // <== This actually removes it from memory
      } else {
        console.warn(`Main: No cleanup function found for ${task}`);
      }
    });

    console.log("Main: Cleanup tasks dispatched.");
  }

  initializeCleanupWorker() {
    this.killCleanupWorker(); // Ensure any existing worker is stopped

    try {
      this.cleanupWorker = new Worker(
        new URL("../cleanupWorker.js", import.meta.url),
      );

      this.cleanupWorker.onerror = (error) => {
        alert("Worker failed to load. Check file path and Network tab.");
        console.error("Worker Error: ", error.message || error);
      };

      console.log("Main: Worker initialized.");
    } catch (e) {
      console.error("Failed to initialize worker: ", e.message || e);
    }
  }

  killCleanupWorker() {
    if (this.cleanupWorker) {
      console.log("Main: Terminating existing cleanup worker.");
      this.cleanupWorker.terminate();
      this.cleanupWorker = null;
    }
  }

  displayCleanupLogs() {
    const logs = JSON.parse(localStorage.getItem("cleanupLogs")) || [];
    if (logs.length > 0) {
      console.log("Previous Cleanup Logs:", logs.join("\n"));
    }
  }
}
